<template>
    <div class="property-feature onlyFiveRows" :class="{ show: show }">
        <h3 class="origin-title f4 text-bold" v-if="orginalCollapse">Additional property details</h3>
        <template v-for="(group, i) in getFeatures">
            <table v-if="group && group.length" v-bind:key="group">
                <tbody>
                    <template v-for="(item, i) in group" v-bind:key="item.name">
                        <tr>
                            <td class="text-bold" :class="{'f4': i === 0}">{{ item.name }}</td>
                            <td>
                                <template v-if="['Virtual Tour'].includes(item.name)">
                                    <a class="link" v-if="dpp.virtualLink" @click="pop3d( dpp.virtualLink)" rel="nofollow" role="button">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <span v-else>N/A</span>
                                </template>
                                <template v-else-if="['3-D Tour','3D Tour'].includes(item.name)">
                                    <a class="link" v-if="dpp.threeDTourLink" @click="pop3d(dpp.threeDTourLink)" rel="nofollow" role="button">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <span v-else>N/A</span>
                                </template>
                                <template v-else-if="(item.name && (~item.name.indexOf('Website') || ~item.name.indexOf('Link')) || item.name == 'Builder') && isValidURL(item.value)">
                                    <a v-if="['Builder','Subdivision Website'].indexOf(item.name) !== -1 " class="link" :href="item.value" rel="nofollow" target="_blank">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <a v-else-if="['Sales Office Website','Home Details Website'].indexOf(item.name) !== -1" class="link" :href="item.value" rel="nofollow" target="_blank">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <a v-else class="link" :href="item.value" rel="nofollow" target="_blank">{{molang('dpp.propertyFeature.extLink')}}</a>
                                </template>
                                <span v-else-if="group.name === 'Rooms Information'"
                                    v-html="item.value.replace('dimension', glb.unit === 'metric' ? item.sizeM : item.sizeI)" />
                                <span v-else>{{item.value}}</span>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
        <button v-if="orginalCollapse" type="button" class="origin-btn link text-bold f6" @click="toggle">{{ show ? 'Show Less' : 'Show All' }} <i
                :class="show ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
        <button v-else type="button" class="link text-bold f6" @click="toggle">{{ show ? 'View less property details' : 'View all property details' }}  <i
            :class="show ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
    </div>
</template>

<script src="./property-feature.js"></script>

<style lang="scss">
    @use './property-feature.scss' as *;
</style>
